import I18N from './interface';

const en: I18N = {
  // Side Menu
  MyWorkItems: 'My Work Items',
  LoadManagement: 'Load Management',
  Communications: 'Communications',
  Compliance: 'Compliance',
  Contracts: 'Contracts',
  Invoices: 'Invoices',
  ScoreCard: 'Score Card',
  AllLoads: 'All Loads',
  LoadBoard: 'Load Board',
  LoadsSummary: 'Loads Summary',
  Search: 'Search...',
  MultipleRoles: 'Multiple Roles',
  CustomerService: 'Customer Service',
  Planner: 'Planner',
  Engineer: 'Engineer',
  ViewProfile: 'View Profile',
  Themes: 'Themes',
  Logout: 'Logout',
  TemplateCustomize: 'Template Customize',
  Customizeandpreview: 'Customize and preview in real time',
  ThemeStyle: 'Theme Style',
  Light: 'Light',
  Dark: 'Dark',
  DarkGreen: 'Dark Green',
  TurkishAqua: 'Turkish Aqua',
  Blue: 'Blue',
  SoothingBreeze: 'Soothing Breeze',
  Languages: 'Languages',
  UnitedStates: 'United States',
  Spanish: 'Spanish',
  German: 'German',
  French: 'French',
  Brazil: 'Brazil',
  QuickLinks: 'Quick Links',
  FailedToFetchTenantDetails: 'Failed to fetch tenant details',
  PageNotFound: 'Page Not Found !',
  Exceptions: 'Exceptions',

  // My work items
  View: 'View',
  Tenders: 'Tenders',
  TotalTenders: 'Total Tenders',
  PendingForAction: 'Pending for Action',
  Accepted: 'Accepted',
  Rejected: 'Rejected',

  UpdateCheckCalls: 'Update Check Calls',
  Total: 'Total',
  Pickups: 'Pickups',
  InTransit: 'In Transit',
  Deliveries: 'Deliveries',

  IntegrationFailure: 'Integration Failure',
  MissingRates: 'Missing Rates',
  InvoiceDiscrepancy: 'Invoice Discrepancy',
  DamagesAndClaims: 'Damages & Claims',
  TrackingMap: 'Tracking Map',

  // all loads
  TenderId: 'Tender ID',
  Status: 'Status',
  Source: 'Source',
  Mode: 'Mode',
  Origin: 'Origin',
  Destination: 'Destination',
  PUDateAndTime: 'PU Date & Time',
  DeliveryDateAndTime: 'Delivery Date & Time',

  DateValidationMessage:
    "Please ensure the 'From Date' is earlier than the 'To Date'.",
  From: 'From',
  To: 'To',
  Clear: 'Clear',
  Apply: 'Apply',

  Details: 'Details',
  UploadAndUpdate: 'Upload & Update',

  // load board

  Actions: 'Actions',
  TransportID: 'Transport ID',
  ScheduledPuDateAndTime: 'Scheduled PU Date & Time',
  TrailerType: 'Trailer Type',
  TransitDays: 'Transit Days',
  UnableToCalculateTransitDays:
    'Unable to calculate the transit days. Please try again.',
  TargetRate: 'Target Rate',
  PostedBy: 'Posted By',
  Comments: 'Comments',
  PostedDateAndTime: 'Posted Date & Time',

  // Common
  Add: 'Add',
  Save: 'Save',
  Cancel: 'Cancel',
  NoDataToShow: 'No Data to Show',
  ChooseFile: 'Choose File',
  NoFileChosen: 'No File Chosen',
  FileSizeInfo: 'PDF and JPEG up to 10MB',

  // Navigation
  MyWork: 'My Work',

  // User
  Admin: 'Admin',

  // Headers
  ContractInformation: 'Contract Information',
  InsuranceInformation: 'Insurance Information',
  LicensingInformation: 'Licensing Information',
  EmissionsCompliance: 'Emissions Compliance',

  // Insurance Form
  InsuranceType: 'Insurance Type',
  AdditionallyInsured: 'Additionally Insured',
  InsuranceCompanyName: 'Insurance Company Name',
  PolicyNumber: 'Policy Number',
  InsuranceContactName: 'Insurance Contact Name',
  InsuranceContactPhone: 'Insurance Contact Phone',
  PolicyAmount: 'Policy Amount',
  RenewalReminderInDays: 'Renewal Reminder (In Days)',
  EffectiveDate: 'Effective Date',
  ExpirationDate: 'Expiration Date',
  UploadDocumentPicture: 'Upload Document / Picture',

  // Licensing Form
  OperatingAuthorityAndLicensing: 'Operating Authority and Licensing',
  LicenseCertificateType: 'License / Certificate Type',
  LicenseCertificateName: 'License / Certificate Name',
  LicenseCertificateNo: 'License / Certificate No',

  // Emissions Form
  CarbonEmissionRating: 'Carbon Emission Rating',
  SafetyRating: 'Safety Rating',
  MinorityCarrier: 'Minority Carrier',
  EnvironmentalCertification: 'Environmental Certification',
  Yes: 'Yes',
  No: 'No',

  // Contract Form
  ContractName: 'Contract Name',
  Description: 'Description',
  Scac: 'SCAC',
  ReferenceNumber: 'Reference Number',
  Currency: 'Currency',
  RenewalReminder: 'Renewal Reminder',
  UploadContract: 'Upload Contract',
  Audit: 'Audit',
  NoDocumentsToShow: 'No Documents to show',

  // Table Headers
  Documents: 'Documents',

  // Placeholders
  EnterName: 'Enter Name',
  EnterContractName: 'Enter contract name',
  EnterContractDescription: 'Enter contract description',
  EnterScac: 'Enter SCAC',
  EnterReferenceNumber: 'Enter reference number',
  EnterPolicyNumber: 'e.g 1234567954',
  EnterAuthority: 'Enter Authority',
  EnterType: 'Enter Type',
  EnterNumber: 'Enter Number',
  SelectDate: 'MM/DD/YYYY',
  Select: 'Select',

  // Import Actions
  Import: 'Import',
  ImportFromPdf: 'Import from PDF',
  ImportFromExcel: 'Import from Excel',
  ImportFromCsv: 'Import from CSV',

  // Create Actions
  CreateNewContract: 'Create New Contract',

  // Search
  SearchByContractName: 'Search by Contract Name',

  // Score Card
  CarrierRating: 'Carrier Rating',
  CalculationInfo: 'Calculation Info',
  KPI: 'KPI',
  WeightedAverage: 'Weighted Average',
  WeightedScore: 'Weighted Score',
  Performance: 'Performance',
  Score: 'Score',

  UpdateDetails: 'Update Details',
  ProNumber: 'Pro Number',
  TelephoneNo: 'Telephone No',
  SealNumber: 'Seal Number',
  TrailerOrContainerNo: 'Trailer / Container No',
  CabOrPowerNo: 'Cab / Power No',
  CustomsSealNumber: 'Customs Seal Number',

  UploadDocuments: 'Upload Documents',
  ReferenceType: 'Reference Type',
  ReferenceNo: 'Reference No',
  AssociateWithShipmentId: 'Associate with Shipment ID',
  UploadDocumentOrPicture: 'Upload Document / Picture',
  PDFandJPEGupto10MB: 'PDF and JPEG up to 10MB',

  UploadPOD: 'Upload POD',
  ShipmentNo: 'Shipment No',
  Name: 'Name',
  DateAndTime: 'Date & Time',
  UploadDocument: 'Upload Document',

  TransportationMode: 'Transportation Mode',
  EquipmentType: 'Equipment Type',
  SealNo: 'Seal No',
  CustomsSealNo: 'Customs Seal No',
  ServiceType: 'Service Type',
  ServiceLevel: 'Service Level',

  ArrivalBegin: 'Arrival Begin',
  ArrivalEnd: 'Arrival End',
  CutTime: 'Cut Time',
  DepartureBegin: 'Departure Begin',
  DepartureEnd: 'Departure End',
  LoadType: 'Load Type',
  DriverName: 'Driver Name',
  // Pending Tenders Grid
  OriginStreetAddress: 'Origin Street Address',
  OriginCity: 'Origin City',
  OriginState: 'Origin State',
  OriginPostalCode: 'Origin Postal Code',
  DestinationStreetAddress: 'Destination Street Address',
  DestinationCity: 'Destination City',
  DestinationState: 'Destination State',
  DestinationPostalCode: 'Destination Postal Code',
  NoOfShipments: 'No of Shipments',
  Quantity: 'Quantity',
  Weight: 'Weight',
  PickupDateTime: 'Pickup Date & Time',
  DeliveryDateTime: 'Delivery Date & Time',
  TenderDate: 'Tender Date',
  Comment: 'Comment',
  WaitingForPickup: 'Waiting for Pickup',
  OnHold: 'On Hold',

  //invoice
  InvoiceNumber: 'Invoice Number',
  Enter: 'Enter',
  InvoiceDate: 'Invoice Date',
  DueDate: 'Due Date',
  DocumentType: 'Document Type',
  SaveAsDraft: 'Save As Draft',
  Send: 'Send',
  TrailerNumber: 'Trailer Number',
  LoadNumber: 'Load Number',
  TotalHUs: "Total HU's",
  TotalWeight: 'Total Weight',
  BaseRate: 'Base Rate',
  Accessorials: 'Accessorials',
  AccessorialRate: 'Accessorial Rate',
  DeliveryFromDate: 'Delivery From Date',
  DeliveryToDate: 'Delivery To Date',
  InvoiceSentDate: 'Invoice Sent Date',
  NoOfLoads: 'No of Loads',
  UploadInvoice: 'Upload Invoice',
  InvoiceHistory: 'Invoice History',
  ShowInvoices: 'Show Invoices',
  Drafts: 'Drafts',

  // Invoice columns
  InvoiceNo: 'Invoice No',

  // Transport View
  TenderDetails: 'Tender Details',
  TenderCutOffTime: 'Tender Cut-Off Time',
  CheckCallRequirements: 'Check Call Requirements',
  Interval: 'Interval',
  CarrierDetails: 'Carrier Details',
  RateInformation: 'Rate Information',
  StopDetails: 'Stop Details',
  AccountInformation: 'Account Information',
  MailInvoiceTo: 'Mail Invoice To',
  ForAccountOf: 'For Account Of',
  Accept: 'Accept',
  Reject: 'Reject',
  ViewBOL: 'View BOL',
  ViewPOD: 'View POD',
  Download: 'Download',
  Print: 'Print',
  New: 'New',
  Stop: 'Stop',
  Pickup: 'Pickup',
  Delivery: 'Delivery',
  DeliveryPickup: 'Delivery / Pick Up',
  ContactInfo: 'Contact Info',
  ShipmentDetails: 'Shipment Details',
  ShipID: 'Ship ID',
  TotalQuantityWeight: 'Total Quantity / Weight',
  HandlingUnits: 'Handling Units',
  Pallets: 'Pallets',
  Boxes: 'Boxes',
  Dimensions: 'Dimensions',
  Notes: 'Notes',

  TotalLoads: 'Total Loads',
  UpcomingLoads: 'Upcoming Loads',
  Delivered: 'Delivered',
  FTLLoads: 'FTL Loads',
  LTLLoads: 'LTL Loads',
  AllInTransitLoads: 'All In Transit Loads',
  AllAcceptedLoadStatus: 'All Accepted Load Status',
  Upcoming: 'Upcoming',
  OnTimeDelivery: 'On Time Delivery',
  DelayedDeliveries: 'Delayed Deliveries',
  OnTimePickup: 'On Time Pickup',
  DelayInTransit: 'Delay In Transit',
  RejectedLoads: 'Rejected Loads',

  LoadsTender: 'Loads Tender',
  InvoiceAccuracy: 'Invoice Accuracy',
  CheckCallAccuracy: 'Check Call Accuracy',
  DamageFreeShipments: 'Damage Free Shipments',
  Professionalism: 'Professionalism',

  ShipmentEntry: 'Shipment Entry',
  HUNo: 'HU No',
  NoOfHUs: 'No Of HU s',
  HUWeight: 'HU Weight',
  Hazmat: 'Hazmat',
  Accessorial: 'Accessorial',
  Border: 'Border',
  ShipmentManifest: 'Shipment Manifest',
  Accessories: 'Accessories',
  TotalQuantity: 'Total Quantity',
  ReferenceAndDocuments: 'References and Documents',
  CarrierInvoiceTo: 'Carrier Invoice To',

  ModesAndEquipment: 'Modes and Equipment',
  PickupWindow: 'Pickup Window',
  DeliveryWindow: 'Delivery Window',
  CostDetails: 'Cost Details',
  RateOnTender: 'Rate on Tender',
  FreightCost: 'Freight Cost',
  FuelCost: 'Fuel Cost',
  TotalCost: 'Total Cost',
  TrackingMethod: 'Tracking Method',
  CheckCalls: 'Check Calls',
  SystemGeneratedDoc: 'System Generated Doc',
  PrintDoc: 'Print Doc',
  TenderInstructions: 'Tender Instructions',

  Sender: 'Sender',
  FileId: 'File ID',
  FileName: 'File Name',
  TransType: 'Transaction Type',
  Receiver: 'Receiver',
  FileType: 'File Type',
  CreatedDateTime: 'Created Date & Time',
  FailureReason: 'Failure Reason',
  Failed: 'Failed',
  InProgress: 'In Progress',
  Completed: 'Completed',
  CarrierPro: 'Carrier Pro',
  LastKnownLocation: 'Last Known Location',
  DestETA: 'Destination ETA',
  // settings
  Settings: 'Settings',
  CarrierProfile: 'Carrier Profile',
  BusinessHours: 'Business Hours',
  Contacts: 'Contacts',
  Contact: 'Contact',
  GeoFence: 'Geo-Fence',
  Equipment: 'Equipment',
  CoverageRegionPreferences: 'Coverage Region Preferences',
  Tracking: 'Tracking',
  PreAssignedReferences: 'Pre-Assigned References',

  CarrierBasicInfo: 'Carrier Basic Info',
  SCAC: 'SCAC',
  MC: 'MC#',
  DOTICC: 'DOT/ICC#',
  FederalTaxID: 'Federal Tax ID',
  CAATCode: 'CAAT Code',
  SVII: 'SVI#',
  CBSA: 'CBSA',
  ModesSupported: 'Modes Supported',
  ModesSupportedItems: ['Air', 'Ground', 'Ocean'],
  EmergencyContactInfo: 'Emergency Contact Info',
  EmergencyContactName: 'Emergency Contact Name',
  EmergencyContactPhone: 'Emergency Contact Phone',
  EmergencyContactEmail: 'Emergency Contact Email',
  PhonePlaceholder: '+1 (000) 000-0000',
  EmailPlaceholder: 'e.g. Location@example.com',
  HazmatAuthorized: 'Hazmat Authorized',

  LocationInformation: 'Location Information',
  LocationEmail: 'Location Email',
  WebsiteURL: 'Website URL',
  BranchCode: 'Branch Code',
  Country: 'Country',
  TimeZone: 'Time Zone',
  EnterWebsiteURL: 'Enter Website URL',
  EnterBranchCode: 'Enter Branch Code',

  LTL: 'LTL',
  FTL: 'FTL',
  Consol: 'Consol',
  Active: 'Active',
  Inactive: 'Inactive',
  CreateNewContact: 'Create New Contact',
  SearchNoDot: 'Search',
  CreateNewRegion: 'Create New Region',
  SearchByNameOrId: 'Search by Name or ID',

  TrackingMethodPriority: 'Tracking Method Priority',
  TrackingReferenceType: 'Tracking Reference Type',
  CheckCallInterval: 'Check Call Interval',
  FailedToCreateTracking: 'Failed to create tracking',
  PrimaryTrackingMethod: 'Primary Tracking Method',
  SecondaryTrackingMethod: 'Secondary Tracking Method',
  TertiaryTrackingMethod: 'Tertiary Tracking Method',
  Update: 'Update',

  ProNumberFrom: 'Pro Number From',
  ProNumberTo: 'Pro Number To',
  CustomTransportNoFrom: 'Custom Transport No From',
  CustomTransportNoTo: 'Custom Transport No To',
  InvoiceNumberFrom: 'Invoice Number From',
  InvoiceNumberTo: 'Invoice Number To',

  // Header Labels
  PartnerInvoice: 'Partner Invoice#',
  PartnerReference: 'Partner Reference#',
  InvoiceDueDate: 'Invoice Due Date',
  PoDate: 'PO Date',
  PoNumber: 'PO Number',
  SenderPartner: 'Sender Partner',
  SenderIsaId: 'Sender ISA ID',
  ReceiverPartner: 'Receiver Partner',
  ReceiverIsaId: 'Receiver ISA ID',
  CreatedByPartner: 'Created By Partner',
  CreatedDate: 'Created Date',

  // Payment Terms Labels
  Type: 'Type',
  BasicCode: 'Basic Code',
  DiscPercentage: 'Disc %',
  DiscDueDays: 'Disc Due Days',
  NetDueDate: 'Net Due Date',
  NetDueDays: 'Net Due Days',
  ShippedDate: 'Shipped Date',

  // Contact Labels
  ContactTypeCode: 'Contact Type Code',
  BasisCode: 'Basis Code',

  // Notes Labels
  NotesInfo: 'Notes Info',

  // Status Labels
  Received: 'Received',
  Processed: 'Processed',
  Error: 'Error',
  Pending: 'Pending',

  // Processing Log Labels
  Id: 'ID',
  LogType: 'Log Type',
  LogDetails: 'Log Details',
  CreatedBy: 'Created By',

  // Raw Data Labels
  RawDataDetails: 'Raw Data Details',
  Json: 'JSON',
  Xml: 'XML',
  Edi: 'EDI',

  // Missing Data Labels
  SummaryOfMissingData: 'Summary of Missing Data',

  // Action Labels
  ReProcess: 'Re-Process',
  ViewRawData: 'View Raw Data',
  Export: 'Export',
  Header: 'Header',

  AddressInformation: 'Address Information',
  CompanyName: 'Company Name',
  AddressLine: 'Address Line',
  City: 'City',
  State: 'State',
  Zip: 'Zip',
  Latitude: 'Latitude',
  Longitude: 'Longitude',
  EnterCompanyName: 'Enter Company Name',
  EnterAddress: 'Enter Address',
  EnterCity: 'Enter City',
  EnterState: 'Enter State',
  EnterZip: 'e.g. 75024',
  EnterLatitude: 'Enter Latitude Value',
  EnterLongitude: 'Enter Longitude Value',
  PersonalInformation: 'Personal Information',
  FirstName: 'First Name',
  EnterFirstName: 'Enter First Name',
  MiddleName: 'Middle Name',
  EnterMiddleName: 'Enter Middle Name',
  LastName: 'Last Name',
  EnterLastName: 'Enter Last Name',
  Alias: 'Alias',
  NickName: 'Nick Name',
  EnterNickName: 'Enter Nick Name',
  LocationName: 'Location Name',
  Title: 'Title',
  EnterTitle: 'Enter Title',
  Department: 'Department',
  Email: 'Email',

  WorkingHours: 'Working Hours',
  Custom: 'Custom',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  SelectWorkingDays: 'Select Working Days',
  DaysSelected: 'Days Selcted',
  ShippingHours: 'Shipping Hours',
  ReceivingHours: 'Receiving Hours',
  SameAsBusinessHours: 'Same as Business Hours',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  DayOff: 'Day Off',
  FailedToCreateBusinessHours: 'Failed To Create Business Hours',
  FailedToUpdateBusinessHours: 'Failed To Update Business Hours',
  FailedToFetchingBusinessHours: 'Failed To Fetching Business Hours',
  MonFri: 'Mon - Fri',
  Open24By7: 'Open24/7',
  GeoFenceName: 'Geo Fence Name',
  EnterGeoFenceName: 'Enter Geo Fence Name',
  CheckCall: 'Check Call',
  OutlineColor: 'Outline Color',
  PostalCode: 'Postal Code',
  DateTime: 'Date & Time',
  ReasonCode: 'Reason Code',
  PlaceholderDateTime: 'MM/DD/YYYY | HH:MM',
  TrackingUpdates: 'Tracking Updates',
  ViewFullDetails: 'View Full Details',
  PrePickupCheckCallTitle: 'Pre-Pickup Check Call Details',
  ScheduledArrivalWindow: 'Scheduled Arrival Window',
  ScheduledArrivalDate: 'Scheduled Arrival Date',
  ContactEmail: 'Contact Email',
  ContactPhone: 'Contact Phone',
  PrimaryContact: 'Primary Contact',
  Address: 'Address',
  StopInformation: 'Stop Information',

  RegionName: 'Region Name',
  US: 'U.S.',
  Canada: 'Canada',
  Mexico: 'Mexico',
  CountrySelectionMandatory: '*Country selection is mandatory to create Area',
  Include: 'Include',
  Exclude: 'Exclude',
  IncludedInArea: 'Included in Area',
  ExcludedFromArea: 'Excluded from Area',
  NoDataToView: 'No Data to view',
  SatSunWillRemainClosed: 'Sat & Sun will remain closed',
  ExceptionReason: 'Exception Reason',
  Miles: 'Miles',
  ContractFreightUSD: 'Contract Freight (USD)',
  FreightOnInvoiceUSD: 'Freight on Invoice (USD)',
  ContractFuelUSD: 'Contract Fuel (USD)',
  FuelOnInvoiceUSD: 'Fuel on Invoice (USD)',
  ContractAccessorialsUSD: 'Contract Accessorials (USD)',
  AccessorialsOnInvoiceUSD: 'Accessorials on Invoice (USD)',
  TotalInvoiceAmount: 'Total Invoice Amount',
  TenderID: 'Tender ID',
  PendingTenders: 'Pending Tenders',
  OperatingAuthority: 'Operating Authority',
  LicenseType: 'License Type',
  LicenseName: 'License Name',
  LicenseNumber: 'License Number',
  EquipmentName: 'Equipment Name',
  GrossWeight: 'Gross Weight',
  Signature: 'Signature',
  AcceptSign: 'Accept & Sign',
  DrawSignature: 'Draw signature with mouse or touch',
  InTransitCheckCallDetails: 'In Transit Check Call Details',
  ClickToSign: 'Click to sign',
  Draw: 'Draw',
  Upload: 'Upload',
  ContractNumber: 'Contract Number',
  OrgInfo: 'Org Info',
  CountryInRegion: 'Country in Region',
  StateInRegion: 'State in Region',
  CityInRegion: 'City in Region',
  PostalCodeInRegion: 'Postal Code in Region',
  ExcludeFromRegion: 'Exclude from Region',
  Region: 'Region',
  FindOnMap: 'Find on Map',
  TenderInstructionMessage: 'Please avoid placing the shipment upside down.',
  Event: 'Event',
  User: 'User',
  EventType: 'Event Type',
  Rates: 'Rates',
  TotalActiveTransports: 'Total Active Transports',
  ScanQRCodeToFillContactInfo: 'Scan QR code to fill contact info',
  CreateNewGeoFence: 'Create New Geo-Fence',
  ExistingGeoFences: 'Existing Geo-Fences',
  SearchByTransportNo: 'Search by Transport No',
  ListView: 'List View',
  TrailerContainerNo: 'Trailer / Container No',
  CabPowerNo: 'Cab / Power No',
  Unfreeze: 'Unfreeze',
  FreezeUpdate: 'Freeze / Update',
  UnfreezeDetails: 'Unfreeze Details',
  FreezeUpdateDetails: 'Freeze Update Details',
  FreezeStartDateTime: 'Freeze Start Date & Time',
  FreezeEndDateTime: 'Freeze End Date & Time',
  Reason: 'Reason',
  Close: 'Close',
  ViewOnMap: 'View on Map',
  ETA: 'ETA',
  ArrivalDateTime: 'Arrival Date / Time',
  CheckCallUpdate: 'Check Call Update',
  ActiveInvoices: 'Active Invoices',
  QuoteId: 'Quote ID',
  BidResponses: 'Bid Responses',
  BidSubmittedDateAndTime: 'Bid Submitted Date & Time',
  BidComments: 'Bid Comments',

  // Create Order Screen
  RemoveCoName: 'Remove C/O Name',
  RemoveHazmat: 'Yes, Remove',
  cancelHazmat: 'No, Cancel',
  RemoveReference: 'Yes, Remove',
  ClearReference: 'Yes, Clear',
  AreYouSureWantToRemoveHazmat:
    'Are you sure, do you want to Remove Hazmat details',
  AreYouSureWantToRemoveReference: 'Are you sure, you want to Remove Reference',
  AreYouSureWantToClearReference: 'Are you sure, you want to Clear Reference',
  ChangeTo: 'Change to',
  Change: 'Change',
  Default: 'Default',
  SearchSupplychainschedule: 'Search Supply chain schedule',
  Format: 'Format',
  Domestic: 'Domestic',
  International: 'International',
  ShipperOriginDetails: 'Shipper / Origin Details',
  SearchLane: 'Search Lane',
  AddNewLocation: 'Add New Location',
  AddLocation: 'Add Location',
  Addtypelocation: 'Add a type for this location',
  Parent: 'Parent',
  SelectParent: ' Select Parent',
  EnterLocationName: 'Enter Location Name',
  EnterExample: 'e.g. 12031411',
  LocationID: 'Location ID',
  SelectCountry: 'Select Country',
  Telephone: 'Telephone',
  EnterMail: 'Enter Mail',
  EnterValue: 'Enter Value',
  Duplications: 'Duplications',
  EnterAlias: 'Enter Alias',
  EnterLocationId: 'Enter Location Id',
  EnterZipCode: 'Enter Zip',
  EnterLatitudeValue: 'Enter Latitude Value',
  EnterLongitudeValue: 'Enter Longitude Value',
  NoDuplicationstoshow: 'No Duplications to show',
  CancelButton: 'Cancel',
  Savebutton: 'Save',
  SaveandNext: 'Save and Next',
  ConsigneeDestinationDetails: 'Consignee / Destination Details',
  AddCOName: 'Add C/O Name',
  EditCOName: 'Edit C/O Name',
  AddedCOName: 'C/O Name Added Successfully',
  UpdatedCOName: 'C/O Name Updated',
  PickupDeliveryWindow: 'Pickup / Delivery Window',
  PickupReadyDate: 'Pickup Ready Date',
  ClosePickupDate: 'Close Pickup Date',
  DeliveryReadyDate: 'Delivery Ready Date',
  DeliveryCloseDate: 'Delivery Close Date',
  InvoicesDetails: 'Invoices Details',
  BillingDetails: 'Billing Details',
  BillTo: 'Bill To',
  HandlingUnitDetails: 'Handling Unit Details',
  HandlingUnitType: 'Handling Unit Type',
  ProductWeight: 'Product Weight',
  NMFC: 'NMFC Code',
  NMFCclass: 'NMFC Class',
  HUDescription: 'HU Description',
  ProductDescription: 'Product Description',
  MostFrequentlyUsedDimensions: 'Most frequently used Dimensions',
  MostFrequentlyUsedAccessorial: 'Most frequently used Accessorial',
  MostFrequentlyUsedProducts: 'Most frequently used Products',
  UNIDNumber: 'UN / ID Number',
  ProperShippingName: 'Proper Shipping Name',
  HazardClass: 'Hazard Class',
  select: 'Select',
  packagingGroup: 'Packaging Group',
  Single: 'Single',
  Composite: 'Composite',
  Combination: 'Combination',
  EmergencyResponsePersonName: 'Emergency Response Person Name',
  EnterPersonName: 'Enter Person Name',
  EmergencyResponseContact: 'Emergency Response Contact',
  EmergencyResponseEmail: 'Emergency Response Email',
  EmergencyResponseEmailExample: 'E.g. john.d@example.com',
  NonStackable: 'Non-Stackable',
  SearchAccessorials: 'Search Accessorials',
  AdditionalPickupServices: 'Additional Pickup Services',
  AdditionalDeliveryServices: 'Additional Delivery Services',
  StorageAndWarehousing: 'Storage and Warehousing',
  TimeAndAppointment: 'Time and Appointment',
  CustomsAndBorder: 'Customs&Border',
  ProductDetails: 'Product Details',
  ProductName: 'Product Name',
  ProductNo: 'Product No',
  InnerPackcode: 'Inner Pack Code',
  OuterPackcode: 'Outer Pack Code',
  WriteHere: 'Write here',
  NoOfDocuments: 'No of Documents',
  InstructionsForPickUpAndDelivery: 'Instructions for Pickup and Delivery',
  InstructionsForPickup: 'Instructions for Pickup',
  InstructionsForDelivery: 'Instructions for Delivery',
  SendUpdatesMobileOrEmail: 'Send updates to mobile no or email',
  Mobile: 'Mobile',
  EnterEmail: 'Enter Email',
  PrintView: 'Preview',
  CreateOrder: 'Create Order',
  CreateNewOrder: 'Create New Order',
  ShipperOrigin: 'Shipper / Origin',
  ShipperName: 'Shipper Name',
  ConsigneeDestination: 'Consignee / Destination',
  ThirdPartyDetails: 'Third Party Details',
  ThirdParty: 'Third Party',
  SearchOrAddThirdPartyDetails: 'Search or Add Third Party Details.',
  Customer: 'Customer',
  PaymentTerms: 'Payment Terms',
  SpecialInstructions: 'Special Instructions',
  Instructions: 'Instructions',
  PickupCloseDate: 'Pickup Close Date',
  SendUpdates: 'Send Updates',
  Value: 'Value',
  Unit: 'Unit',
  CODAmount: 'COD Amount',
  Amount$: 'Amount($)',
  FeeTerms: 'Fee Terms',
  Collect: 'Collect',
  PrePaid: 'PrePaid',
  Customercheckacceptable: 'Customer check acceptable',
  NOTE: 'NOTE',
  ShipperSignatureDate: 'Shipper Signature/Date',
  TrailerLoaded: 'Trailer Loaded',
  ByShipper: 'By Shipper',
  ByDriver: 'By Driver',
  FreightCounted: 'Freight Counted',
  ByDriverPalletssaidtocontain: 'By Driver/Pallets said to contain',
  ByDriverPlaces: 'By Driver/Places',
  ShipperSignature: 'Shipper Signature',
  Signaturehere: 'Signature here',
  CarrierSignaturePickupDate: 'Carrier Signature/Pickup Date',
  PickupDate: 'Pickup Date',
  BillofLadingNo: 'Bill of Lading No',
  CarrierName: 'Carrier Name',
  TrailerNo: 'Trailer No',
  SCACNo: 'SCAC No',
  EnterSCACNo: 'Enter SCAC No',
  PRONo: 'PRO No',
  EnterPRONo: 'Enter PRO No',
  Emailexample: 'e.g john.d@example.com',
  LocationNotCreated: 'Location not Created.',
  LocationCreationFailed: 'Location creation failed.',
  Account: 'Account',
  AddTypeLocation: 'Add a type for this location.',
  ShipmentLoadingFailed: 'Shipment settings loading failed.',
  OrderLoadingFailed: 'Order settings loading failed.',
  FailedToFetchOrderDetails: 'Failed to fetch order details.',
  FailedToFetchAsns: 'Failed to fetch ASNs',
  ShipmentType: 'Shipment Type',
  ReferenceTypeLoadingFailed: 'Reference type loading failed',
  DocumentUploadSuccessfully: 'Document uploaded successfully.',
  DocumentUploadFailed: 'Document upload failed.',
  ShipmentNotCreated: 'Shipment not created.',
  OrderCreationFailed: 'Order creation failed.',
  OrderCreatedSuccessfully: 'Order Created Successfully',
  PrintAsBol: 'Print as BOL',
  EmailAsBol: 'Email as BOL',
  EmailAsAttachment: 'Email as attachment',
  ForAnyQueries: 'For any queries please contact.',
  FailedToLoadUomDetails: 'Failed to get UOM details.',
  LxWxHx: '(LxWxH)',
  DxH: '(DxH)',
  DxW: '(DxW)',
  ThisHandlingUnitTypeIsAlreadySelected:
    'This handling unit type is already selected.',
  ModeTypeService: 'Mode/Type/Service',

  //validation rules
  EmailRequiredRule: 'Email is required.',
  EmailInValidRule: 'Email is invalid.',
  DefaultMobileRowRule: "Default mobile number can't be removed.",
  DefaultEmailRowRule: "Default email can't be removed.",
  DefaultProductRule: 'Default product cannot be removed.',
  InvalidYear: 'Invalid year',

  // Date validation rules
  DeliveryCloseDateMustBeLaterThanDeliveryReadyDate:
    'Delivery Close Date must be later than Delivery Ready Date',
  DeliveryCloseDateMustBeLaterThanPickupCloseDate:
    'Delivery Close Date must be later than Pickup Close Date',
  DeliveryCloseDateMustBeLaterThanPickupReadyDate:
    'Delivery Close Date must be later than Pickup Ready Date',
  DeliveryReadyDateMustBeLaterThanPickupCloseDate:
    'Delivery Ready Date must be later than Pickup Close Date',
  DeliveryReadyDateMustBeLaterThanPickupReadyDate:
    'Delivery Ready Date must be later than Pickup Ready Date',
  DeliveryReadyDateMustBeEarlierThanDeliveryCloseDate:
    'Delivery Ready Date must be earlier than Delivery Close Date',
  PickupCloseDateMustBeLaterThanPickupReadyDate:
    'Pickup Close Date must be later than Pickup Ready Date',
  PickupCloseDateMustBeEarlierThanDeliveryReadyDate:
    'Pickup Close Date must be earlier than Delivery Ready Date',
  PickupCloseDateMustBeEarlierThanDeliveryCloseDate:
    'Pickup Close Date must be earlier than Delivery Close Date',
  PickupReadyDateMustBeEarlierThanPickupCloseDate:
    'Pickup Ready Date must be earlier than Pickup Close Date',
  PickupReadyDateMustBeEarlierThanDeliveryReadyDate:
    'Pickup Ready Date must be earlier than Delivery Ready Date',
  PickupReadyDateMustBeEarlierThanDeliveryCloseDate:
    'Pickup Ready Date must be earlier than Delivery Close Date',
  NoInstructionsToShow: 'No instructions to show',
  EnterNewInstruction: 'Enter new instruction',
  PickupInstructions: 'Pickup Instructions',
  DeliveryInstructions: 'Delivery Instructions',

  //manage orders
  AddNewOrder: 'Add New Order',
  Refresh: 'Refresh',
  Carrier: 'Carrier',
  OrderTrackingNo: 'Order Tracking No',
  OrderDate: 'Order Date',
  PickUpDateTime: 'Pickup Date/Time',
  DueDateTime: 'Due Date/Time',
  InternalCommunication: 'Internal Communication',
  NoPreviousComments: 'No Previous Comments',
  EnterNewComments:
    'Add a comment. Use # to link a work item, @ to mention a person',
  AddInternalCommunication: 'Add Internal Communication',
  AddExternalCommunication: 'Add External Communication',
  AddTenderCommunication: 'Add Tender Communication',
  ExternalCommunication: 'External Communication',
  TenderCommunication: 'Tender Communciation',
  AttachEmail: 'Attach Email',
  NoImagesToShow: 'No Images To Show.',
  PngJpg: 'PNG, JPG upto 10MB',
  UploadFile: 'Upload File',
  OrDragAndDrop: 'or drag and drop.',
  NoEmailsToShow: 'No Email To Show.',
  DriverDetails: 'Driver Details',
  CheckCallFrequency: 'Check Call Frequency',
  TrackingType: 'Tracking Type',
  CarrierProNumber: 'Carrier Pro Number',
  TenderMethod: 'Tender Method',
  TenderResponseTime: 'Tender Response Time.',
  DotIcc: 'DOT/ICC#',
  StrategyNumber: 'Strategy Number',
  ShippingName: 'Shipping Name',
  ConsigneeDetails: 'Consignee Details',
  ChargeType: 'Charge Type',
  Cost: 'Cost (USD)',
  Charge: 'Charge (USD)',
  BillToDetails: 'Bill To Details',
  CustomerDetails: 'Customer Details',
  NoCommunicationsToShow: 'No Communication to Show.',
  Lb: 'lb',
  ExcelDocPdfJpeg: 'Excel, Doc, PDF and JPEG up to 10MB.',
  AllOrders: 'All Orders',
  NoOfExceptions: 'No of Exceptions',

  //Shipment Management
  ShipmentManagement: 'Shipment Management',
  ExpediteShipments: 'Expedite Shipments',
  FailedToFetchOriginDetails: 'Failed to fetch origin details',
  FailedToFetchDestinationDetails: 'Failed to fetch destination details',
  FailedToFetchBillToDetails: 'Failed to fetch bill to details',
  FailedToFetchShipmentDetails: 'Failed to fetch shipment details',
  FailedToFetchCustomerDetails: 'Failed to fetch customer details',
  FailedToFetchAccounts: 'Failed to fetch accounts',
  ShipmentStatus: 'Shipment Status',
  Created: 'Created',
  ReadyForPickup: 'Ready for Pickup',
  Hold: 'Hold',
  PickupStarted: 'Pickup Started',
  PickedUp: 'Picked Up',
  DeliveryStarted: 'Delivery Started',
  ReadyToInvoice: 'Ready To Invoice',
  OnInvoice: 'On Invoice',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
  PuDateAndTime: 'PU Date & Time',
  PickupCarrier: 'Pickup Carrier',
  NoOfHus: "No Of HU's",
  ShpNo: 'Shp No',
  ShipmentId: 'Shipment ID',
  ToViewShipmentsPleaseSelectTheAboveOptions:
    'To view Shipments, please select the above options',
  RateDetails: 'Rate Details',
  TenantDetails: 'Tenant Details',
  PuFromDate: 'PU From Date',
  PuToDate: 'PU To Date',
  ToDateShouldBeGreaterFromDate:
    'To Date should be greater than or equal to From Date',
  Remove: 'Remove',
  SystemGeneratedDocument: 'System Generated Document',
  NothingToShow: 'Nothing To Show',
  LineHaulSegment: 'Linehaul Segment',
  ReferenceDocuments: 'References & Documents',
  ReferencesUploadedSuccessfully: 'References uploaded successfully.',
  ReferencesUploadFailed: 'References upload failed.',
  ReferenceRemovedSuccessfully: 'Reference removed successfully.',
  ReferenceRemovedFailed: 'Reference removed failed.',
  Attach: 'Attach',
  Qty: 'Qty',
  HUType: 'HU Type',
  ShipperDetails: 'Shipper Details',
  FailedToFetchTrackingUpdates: 'Failed to fetch tracking updates',
  NoDefaultContactToShow: 'No Default Contact to show.',
  ShowShipments: 'Show Shipments',
  PleaseSelectFromDate: 'Please select from date',
  PleaseSelectViewOption: 'Please select type option',
  HideConversion: 'Hide Conversion',
  ViewConversion: 'View Conversion',

  //CheckCallUpdate
  CurrentShipmentLocation: 'Current Shipment Location',
  ArrivalDate: 'Arrival Date',
  DepartureDate: 'Departure Date',
  ActualArrivalDate: 'Actual Arrival Date',
  ActualArrivalTime: 'Actual Arrival Time',
  FreezeUpdates: 'Freeze Updates',
  StartDateAndTime: 'Start Date & Time',
  EndDateAndTime: 'End Date & Time',

  //ExceptionTab
  ShipmentID: 'Shipment ID',

  //AuditTab
  OrderDetails: 'Order Details',
  PreviousDetail: 'Previous Detail',
  CurrentDetail: 'Current Detail',
  CustomerServiceContacts: 'Customer Service Contacts',

  //CommunicationTab
  CarrierContacts: 'Carrier Contacts',
  UploadFileInstructions: 'PNG,JPG,JIF Up to 10MB',
  InternalComments: 'Internal Comments',
  ExternalComments: 'External Comments',
  TenderComments: 'Tender Comments',
  TendersComments: 'Tenders Comments',
  Notifications: 'Notifications',
  Tenant: 'Tenant',

  StopCheckCallDetails: 'Stop Check Call Details',
  AddressDetails: 'Address Details',
  TotalHUQuantity: 'Total HU Quantity',
  ArrivalDetails: 'Arrival Details',
  ScheduledArrival: 'Scheduled Arrival',
  ActualArrivalDateAndTime: 'Actual Arrival Date & Time',
  DepartureDetails: 'Departure Details',
  ScheduledDeparture: 'Scheduled Departure',
  TelephoneNumber: 'Telephone Number',
  ArrivalDateOrTime: 'Arrival Date/Time',
  PreviousCheckCall: 'Previous Check Call',
  DocumentsRequiredAtTheStop: 'Documents Required at the Stop',
  BillOfLading: 'Bill of Lading',
  PurchaseOrder: 'Purchase Order',
  CommercialInvoice: 'Commercial Invoice',
  LocationContact: 'Location Contact',
  NextStop: 'Next Stop',
  Eta: 'ETA',

  //ShipmentMilestones
  ShipmentMilestones: 'Shipment Milestones',
  Incomplete: 'Incomplete',
  Missing: 'Missing',
  Note: 'Note',
  MilestoneNoteDetails: 'Events marked with "{star}" are required.',

  //RateShop
  HandlingUnit: 'Handling Unit',
  Product: 'Product',
  Map: 'Map',
  RouteMap: 'Route Map',
  AccessorialNotRequired: 'Accessorial not required',
  PickupDeliveryDetails: 'Pickup / Delivery Details',
  DeliveryDate: 'Delivery Date',
  Preview: 'Preview',
  SendForApproval: 'Send for Approval',
  ContractedRate: 'Contracted Rate',
  Rating: 'Rating',
  Price: 'Price',
  QuoteHistory: 'Quote History',
  ContractRate: 'Contract Rate',
  PostalFrom: 'Postal From',
  PostalTo: 'Postal To',
  MarketRate: 'Market Rate',
  Category: 'Category',
  CostPerMile: 'Cost Per Mile',
  SendToMarketBoard: 'Send to Market Board',
  Rate: 'Rate',
  GetRates: 'Get Rates',
  QuoteDetails: 'Quote Details',
  NoRatesToShow: 'No Rates to Show',
  MarkupAmount: 'Markup Amount',
  MarkDefault: 'Mark Default',
  ContactMarkedAsDefaultSuccessfully: 'Contact marked as default successfully!',
  FailedToAssociateContact: 'Failed to associate contact',
  NoContactSelectedAsDefault: 'No contact selected as default',
  EditContact: 'Edit Contact',
  SearchByNameOrRole: 'Search by Name or role',
  LoadingMap: 'Loading Map',
  RateHistory: 'Rate History',

  CreateASN: 'Create ASN',
  SearchASN: 'Search ASN',

  // ASN
  AsnTitle: 'Advanced Shipment Notice',
  AccountLabel: 'Account',
  AccountPlaceholder: 'Select Account',

  // Order
  OrderTitle: 'Order',
  DetailsTitle: 'Details',
  Buyer: 'Buyer',
  Supplier: 'Supplier',
  DestinationCO: 'Destination C/O',

  // Date Information
  DateInformationTitle: 'Date Information',
  AsnCreateDateTime: 'ASN Create Date & Time',

  // Reference Details
  ReferenceDetailsTitle: 'Reference Details',

  // Transportation Information
  TransportationInformationTitle: 'Transportation Information',
  NetWeight: 'Net Weight',
  PayerTermType: 'Payor Term Type',

  // Handling Unit
  HandlingUnitTitle: 'Handling Unit',
  NmfcClass: 'NMFC Class',
  NmfcCode: 'NMFC Code',
  HUDescBol: 'HU Desc',

  // International Shipments
  InternationalShipmentsTitle: 'International Shipments',
  HsCode: 'HS Code',
  CountryOfOrigin: 'Country of Origin',
  CustomsValue: 'Customs Value',
  ExportLicenseNumber: 'Export License Number',
  ImportLicenseNumber: 'Import License Number',
  TaxId: 'Tax ID',

  // ASN Products
  AsnProductsTitle: 'ASN Products',
  ExpectedDate: 'Expected Date',
  ReleaseVersion: 'Release Version',
  OrderSeqNo: 'Order Seq No',
  BlindRec: 'Blind Rec',
  Volume: 'Volume',
  LastModified: 'Last Modified',
  LatestReleaseReceiptDate: 'Latest Release Receipt Date',
  ApportionedWeight: 'Apportioned Weight in Pounds',
  UtilizationByWeight: 'Utilization by Weight',
  UtilizationByDimensions: 'Utilization by Dimensions',
  TrueCBM: 'True CBM',
  LiquidCube: 'Liquid Cube',
  SecondaryContainer: 'Secondary Container per Product',
  Manifest: 'Manifest',

  // Common
  Loading: 'Loading...',
  SaveSuccess: 'Successfully saved',
  SaveFailed: 'Failed to save',

  // Units
  Usd: 'USD',
  Eur: 'EUR',
  Gbp: 'GBP',
  Lbs: 'LBS',
  Kg: 'KG',
  Inches: 'Inches',
  Cm: 'CM',

  ForwardingAgent: 'Forwarding Agent',
  CustomerProductId: 'Customer Product ID',
  OriginProductId: 'Origin Product ID',
  ExpectedPrimaryPackagingId: 'Expected Primary Packaging ID',
  ExpectedSecondaryPackagingId: 'Expected Secondary Packaging ID',
  Uom: 'Unit of Measure',
  Release: 'Release',
  QuantityExpected: 'Quantity Expected',
  QuantityReported: 'Quantity Reported',
  SecondaryContainerPerProduct: 'Secondary Container Per Product',
  ApportionedWeightInPounds: 'Apportioned Weight in Pounds',
  PurchaseOrderNo: 'Purchase Order Number',
  PurchaseOrderLineNo: 'Purchase Order Line Number',
  ScheduleNo: 'Schedule Number',
  QuantityPackageExpected: 'Quantity Package Expected',
  QuantityPackageReceived: 'Quantity Package Received',
  QuantityPackageReported: 'Quantity Package Reported',
  Validated: 'Validated',
  PackingSlip: 'Packing Slip',
  QuantityReceived: 'Quantity Received',
  WeightUnit: 'Weight Unit',
  ASNOrderManagement: 'ASN',
  TotalVolume: 'Total Volume',

  //Pod Details
  PodDetails: 'POD Details',
  NoDocumentUploaded: 'No Document Uploaded',
  Document: 'Document',
  NoSignatureCaptured: 'No Signature Captured',
  PodSavedSuccessfully: 'POD details saved successfully.',
  PodUpdatedSuccessfully: 'POD details updated successfully.',

  //Signature Popup
  DrawSignatureWithMouseOrTouch: 'Draw Signature with mouse or touch',
  ClickToUpload: 'Click to upload',
  NoDataAttachedYet: 'No data attached yet',

  //Cancel Shipment
  CancelShipment: 'Cancel Shipment',
  AddContact: 'Add Contact',
  AdditionalContact: 'Additional Contact',
  AddNewContact: 'Add New Contact',
  ReasonForCancel: 'Reason for Cancel',
  AdditionalChargesIfApplicable: 'Additional Charges (if applicable)',
  CancelledBy: 'Cancelled By',
  CancellationNotificationWillBeSentToFollowingUsers:
    'Cancellation notification will be sent to following users:',
  DontCancel: "Don't Cancel",
  CancelAndNotify: 'Cancel & Notify',
  ThisContactIsAlreadyAdded: 'This contact is already added',

  MobileDetails: 'Mobile Details',
  EmailDetails: 'Email Details',
  MobileNumberIsRequired: 'Mobile number is required.',
  CountryCodeMustStartWithPlus: 'Country code must start with "+".',
  EnterCountryCodeAfterPlus: 'Enter country code after "+".',
  CountryCodeMustBeNumeric: 'Country code must be numeric.',
  GiveOneSpaceAfterCountryCode: 'Give one space after country code.',
  InvalidCountryCodeMaxThreeDigits: 'Invalid country code (max-3).',
  OnlyOneSpaceIsAllowedAfterTheCountryCode:
    'Only one space is allowed after the country code.',
  MobileNumberIsRequiredAfterCountryCode:
    'Mobile number is required after country code.',
  MobileNumberMustBeNumeric: 'Mobile number must be numeric.',
  InvalidMobileNumberMinTenDigits: 'Invalid mobile number (min-10).',
  EmailIsRequired: 'Email is required.',
  IncorrectFormat: 'Incorrect format.',

  //Bol
  LiabilityNote:
    'Liability Limitation for loss or damage in this shipment may be applicable. See 49 USAC.14706(c)(1)(A) and (B).',
  LiabilityReceived:
    'RECEIVED, subject to individually determined rates or contracts that have been agreed upon in writing between the carrier and shipper, if applicable, otherwise to the rates, classifications and rules that have been established by the carrier and are available to the shipper, on request, and to all applicable state and federal regulations.',
  CarrierNote:
    'The carrier shall not make delivery of this shipment without payment of freight and all other lawful charges.',
  CarrierAcknowledge:
    'Carrier acknowledges receipt of packages and required placards. Carrier certifies emergency response information was made available and/or carrier has the DOT emergency response guidebook or equivalent documentation in the vehicle.',
  ShipperCertification:
    'This is to certify that the above named materials are properly classified, packaged, marked and labeled, and are in proper condition for transportation according to the applicable regulations of the DOT. All cargo tendered for transport is subject to inspection. by tendering cargo to carrier, shipper grants consent to such an inspection.',
  CODValueDeclaration:
    'Where the rate is dependent on value, shippers are required to state specifically in writing the agreed or declared value of the property as follows:',
  CODStatement:
    'The agreed or declared value of the property is specifically stated by the shipper to be not exceeding',
  Per: 'Per',
  BarCodeSpace: 'BAR CODE SPACE',
  ContactPersonFullName: 'Contact Person Full Name',
  EnterFullName: 'Enter Full Name',
  PayorTerms: 'Payor Terms',
  SearchByOrderIDOrShipmentID: 'Search by Order ID or Shipment ID',
  AccountDetails: 'Account Details',
  ToViewOrdersPleaseSelectTheAboveOptions:
    'To view Orders, please select the above options',
  OrderManagement: 'Order Management',
  ShowOrders: 'Show Orders',
  OrderID: 'Order ID',
  Shipments: 'Shipments',
  NoContactToShow: 'No contact to show.',
  ContactAddedSuccessfully: 'Contact added successfully',
  DefaultContact: 'Default Contact',
  DestinationContacts: 'Destination Contacts',
  OriginContacts: 'Origin Contacts',
  NoContactsToShow: 'No Contacts to Show',
  FailedToGetContactDetails: 'Failed To Get Contact Details',
  FailedToGetResources: 'Failed To Get The Resources',
  FailedToGetDepartments: 'Failed To Get The Departments',
  NoExceptionsToShow: 'No Exceptions to Show.',
  NoCarriersToShow: 'No Carriers to Show.',

  //ASN Management
  ASNManagement: 'ASN Management',
  PreAlert: 'Pre-Alert',
  ASN: 'ASN',
  AutomatedASNs: 'Automated ASNs',
  PreviewPreAlert: 'Preview Pre-Alert',
  ViewASN: 'View ASN',
  PreviewASN: 'Preview ASN',
  PreAlertEmptyText: 'To Send Pre-Alert, Search & Enter Shipment No',
  ASNEmptyText: 'To Send ASN, Search & Enter Shipment No',
  DestinationContact: 'Destination Contact',
  SendPreAlert: 'Send Pre-Alert',
  InnerPackCode: 'Inner Pack Code',
  OuterPackCode: 'Outer Pack Code',
  PleaseEnterEmail: 'Please enter Email',
  PreAlertSentTo: 'Pre-Alert sent to',
  PreAlertSentSuccessfully: 'Pre-Alert sent successfully',
  Ok: 'Ok',
  ActualPickupDate: 'Actual Pickup Date',
  ASNLevel: 'ASN Level',
  PlannedDepartureDate: 'Planned Departure Date',
  SendASN: 'Send ASN',
  ShipmentNumber: 'Shipment Number',

  //check calls
  PickupRequirementsTitle: 'Pickup Requirements',
  OrDropFileHere: 'Or drop file here',
  SelectReferenceType: 'Select reference type',
  AllRouteStops: 'All Route Stops',
  BreakStart: 'Break Start',
  BreakEnd: 'Break End',
  DocumentsReferences: 'Documents / References',
  ContactName: 'Contact Name',
  ActualDepartureDateAndTime: 'Actual Departure Date and Time',
  UploadedDocument: 'Uploaded Document',
  Location: 'Location',
  LocationUpdate: 'Location Update',
  NoCheckCallstoShow: 'No check calls to show',
  NotAvailable: 'Not Available',
  EnterTrailerContainerNo: 'Enter Trailer/Container No',
  CarrierContact: 'Carrier Contact',
  EnterTelephoneNo: 'Enter Telephone No',
  EnterCabPowerNo: 'Enter Cab/Power No',
  CarrierEmail: 'Carrier Email',
  InTransitCheckCalls: 'In-Transit Check Calls',
  TotalHuQty: 'Total HU Qty',
  InTransitCheckCallUpdate: 'In-Transit Check Call Update',
  ManualUpdate: 'Manual Update',
  InTransitCheckCall: 'In-Transit Check Call',
  PrePickupCheckCall: 'Pre-Pickup Check Call',
  InfoCheckCall: 'Info Check Call',

  //TemperatureControlled
  TemperatureControlled: 'Temperature Controlled',
  MinimumTemperature: 'Minimum Temperature',
  MaximumTemperature: 'Maximum Temperature',
  AlertThreshold: 'Alert Threshold',
  MonitoringFrequency: 'Monitoring Frequency (HH:MM)',
  CelsiusLabel: 'Celsius (°C)',
  FahrenheitLabel: 'Fahrenheit (°F)',
  AreYouSureDoYouWantToRemoveTemperatureControlledDetails:
    'Are you sure do you want to remove Temperature Controlled details?',
  AlertWhenTemperatureDeviatesBy: 'Alert when temperature deviates by',
  AlertTriggerIfTemperatureGoesOutsideTheAllowedRangeByThisValue:
    'Alert trigger if temperature goes outside the allowed range by this value.',
  MinutesMustBeInBetween00And59: 'Minutes must be in between 00 and 59',
  NoCancel: 'No, Cancel',
  YesRemove: 'Yes, Remove',
  MaximumTemperatureShouldBeGreaterThanMinimumTemperature:
    'Maximum temperature should be greater than minimum temperature',
  TemperatureControlledDetails: 'Temperature Controlled Details',
  HazmatDetails: 'Hazmat Details',
  Hours: 'Hours',
  Minutes: 'Minutes',
  UOM: 'UOM',
  SpecialHandling: 'Special Handling',
  MonitoringFrequencyLabel: 'Monitoring Frequency',
  AddNew: 'Add New',
  NoAccessorialFound: 'No Accessorial Found',
  RateShop: 'Rate Shop',
  PickupPreAlert: 'Pickup Pre-Alert',
  DeliveryASNs: 'Delivery ASNs',
  AutomatedDeliveryASNs: 'Automated Delivery ASNs',
  CreateNewLocation: 'Create New Location',
  PrePickup: 'Pre-Pickup',
  EtaFinalDestinationOnTime: 'ETA (Final Destination) - On Time',
  DateSlashTime: 'Date/Time',
  MostRecent: 'Most Recent',
  PickupShipments: 'Pickup Shipments',
  DeliveryShipments: 'Delivery Shipments',
  Edit: 'Edit',
  ScheduledArrivalDateAndTimeWindow: 'Scheduled Arrival Date and Time Window',
  ViewLess: 'View Less',
  ViewMore: 'View More',
  SelectPickupShipmentsOptional: 'Select Pickup Shipments (Optional)',
  SelectDeliveryShipmentsOptional: 'Select Delivery Shipments (Optional)',
  ReportException: 'Report Exception',
  Arrival: 'Arrival',
  Departure: 'Departure',
  Clone: 'Clone',
  StandardServiceLevelType: 'Standard Service Level Type',
  ExpediteServiceLevelType: 'Expedite Service Level Type',
  Unknown: 'Unknown',
  CreateNew: 'Create New',
  CreateNewHandlingUnit: 'Create New Handling Unit',
  HandlingUnitName: 'Handling Unit Name',
  Length: 'Length',
  Width: 'Width',
  Height: 'Height',
  Density: 'Density',
  LoadRestrictions: 'Load Restrictions',
  EdiDescriptionCode: 'EDI Description Code',
  MarkAsDefault: 'Mark As Default',
  TrailerUtilizationParameters: 'Trailer Utilization Parameters',
  Shape: 'Shape',
  Orientation: 'Orientation',
  MaxStackQty: 'Max Stack Qty',
  DimensionsLWH: 'Dimensions (L x W x H)',
  DimensionsDL: 'Dimensions (D x L)',
  Zero: '0',
  ZeroDecimalPlaceholder: '0.00',
  DeliveryCarrier: 'Delivery Carrier',
  TenderAcceptance: 'Tender Acceptance',
  Auto: 'Auto',
  Manual: 'Manual',
  OrderReferenceAndDocuments: 'Order Reference And Documents',
  ShipmentReferenceAndDocuments: 'Shipment Reference And Documents',
  TransportReferenceAndDocuments: 'Transport Reference And Documents',
  TransportId: 'Transport ID',
  HuId: 'HU ID',
  ActualHUQuantity: 'Actual HU Quantity',
  ActualHUWeight: 'Actual HU Weight',
  TotalHUWeight: 'Total HU Weight',
  TotalHUQty: 'Total HU Qty',
  PodRequiredShipments: 'POD Required Shipments',
  PodSubmittedShipments: 'POD Submitted Shipments',
  RateSource: 'Rate Source',
  ContractNo: 'Contract No',
  ContractType: 'Contract Type',
  General: 'General',
  ToEditAChargeClickTheValueInTheGrid:
    'To edit a charge, click the value in the grid.',
  ConversionRateMXN: 'Conversion Rate (MXN)',
  BilledChargeMXN: 'Billed Charge (MXN)',
  NoteEitherEmailOrTelephoneIsRequired:
    'Note: * Either Email or Telephone is required.',

  // Create Quote
  DefaultProductCannotBeRemoved: 'Default product cannot be removed.',
  PackagingGroup: 'Packaging Group',
  quoteCreationFailed: 'Quote creation failed.',
  FailedToFetchProducts: 'Failed to fetch products',
  RequestedBy: 'Requested By',
  EmailExample: 'e.g john.d@example.com',
  QuoteSubmittedSuccesfully: 'Quote Submitted Successfully',
  QuoteNo: 'Quote No',
  EmailAsAttactment: 'Email as Attactment',
  Submit: 'Submit',
  QuotationRequest: 'Quotation Request',
  PickupDateAndTime: 'Pickup Date & Time',
  DestinationDetails: 'Destination Details',
  CardView: 'Card View',
  GridView: 'Grid View',

  // Home - Operational View / BI View
  OperationalView: 'Operational View',
  BiView: 'BI View',
  BiViewComingSoon: 'BI View is coming soon.',
  HomeViewInfoTooltip: 'Switch between the Operational View and BI View.',
  Accounts: 'Accounts',
  SelectAccountsPlaceholder: 'Select Accounts',
  AllPendingApprovals: 'All Pending Approvals',
  QuoteRequests: 'Quote Requests',
  WeeklySchedules: 'Weekly Schedules',
  ShipmentsPickupForToday: 'Shipments Pickup for Today',
  ScheduledPickups: 'Scheduled Pickups',
  AlreadyPickedUp: 'Already Picked up',
  TotalShipmentsInTransit: 'Total Shipments in Transit',
  ShipmentsDeliveryForToday: 'Shipments Delivery for Today',
  ScheduledDeliveries: 'Scheduled Deliveries',
  AlreadyDelivered: 'Already Delivered',
  TotalExpediteShipments: 'Total Expedite Shipments',
  TotalLateShipments: 'Total Late Shipments',
  QuickActions: 'Quick Actions',
  CreateQuote: 'Create Quote',
  CreateContactSupport: 'Create Contact Support',

  // Home - date range filter (shared with Shipments)
  Today: 'Today',
  Day: 'Day',
  DateRange: 'Date Range',

  // Shipments
  Home: 'Home',
  All: 'All',
  HeatMap: 'Heat Map',
  SearchByShipmentId: 'Search by Shipment ID',
  ShipmentsInfoTooltip:
    'Search and filter shipments by pickup, transit, and delivery status.',
  DocumentsInfoTooltip:
    'Attach a reference and document to an existing shipment.',
  Expedite: 'Expedite',
  Standard: 'Standard',
  HuProduct: 'HU / Product',

  // Quote Management
  QuoteManagement: 'Quote Management',
  PendingForApproval: 'Pending for Approval',
  Approved: 'Approved',
  SearchByQuoteId: 'Search by Quote ID',
  QuoteManagementInfoTooltip:
    'Search and filter quotes by request, approval, and decision status.',
  ApprovalNotes: 'Approval Notes',
  RejectionNotes: 'Rejection Notes',
  Approve: 'Approve',
  SelectAQuoteToViewItsAuditTrail: 'Select a quote to view its audit trail.',
  QuotesLoadingFailed: 'Failed to load quotes',
  QuoteDecisionSubmittedSuccessfully: 'Decision submitted successfully',
  QuoteDecisionPartialFailure:
    '{success} of {total} quotes updated, {failed} failed',
  QuoteDecisionFailed: 'Failed to submit decision',
  TotalCharges: 'Total Charges',

  // Invoices
  InvoicedShipments: 'Invoiced Shipments',
  ShipmentsAreNotInvoiced: 'Shipments are not Invoiced',
  DisputedInvoices: 'Disputed Invoices',
  SearchByShipmentIdInvoiceNo: 'Search by Shipment ID, Invoice No',
  InvoicesInfoTooltip:
    'View invoiced shipments, shipments awaiting invoicing, and disputed invoices.',
  Submitted: 'Submitted',

  // Invoice detail / Raise a Dispute
  GoBack: 'Go Back',
  Date: 'Date',
  Amount: 'Amount',
  Items: 'Items',
  AmountDue: 'Amount Due',
  SubTotal: 'Sub-Total',
  TaxRate: 'Tax Rate',
  Tax: 'Tax',
  RaiseADispute: 'Raise a Dispute',
  DisputeReason: 'Dispute Reason',
  DisputedAmountUSD: 'Disputed Amount (USD)',
  DisputeDescription: 'Dispute Description',
  DisputeDescriptionPlaceholder:
    'Please describe the issue with this invoice...',
  PngJpgUpTo10Mb: 'PNG, JPG up to 10MB',
  SubmitDispute: 'Submit Dispute',
  IncorrectCharges: 'Incorrect Charges',
  MissingProofOfDelivery: 'Missing Proof of Delivery',
  RateMismatch: 'Rate Mismatch',
  DuplicateInvoice: 'Duplicate Invoice',
  AccessorialChargeIssue: 'Accessorial Charge Issue',
  TaxIssue: 'Tax Issue',
  Other: 'Other',
  DisputeSuccessfullySubmitted: 'Dispute successfully submitted',
  DisputeReferenceNo: 'Dispute Reference No',

  // Lanes & Logistics Plan
  LanesAndLogisticsPlan: 'Lanes & Logistics Plan',
  LanesAndLogisticsPlanInfoTooltip:
    'Track weekly schedules, lanes in the logistics plan and pre-alerts / ASN at a glance.',
  SearchBy: 'Search by',
  CurrentWeekSchedules: 'Current Week Schedules',
  WeeklyScheduleApprovalRequest: 'Weekly Schedule Approval Request',
  ApprovedWeeklySchedules: 'Approved Weekly Schedules',
  LanesInLogisticsPlan: 'Lanes in Logistics Plan',
  PreAlertsAsn: 'Pre-alerts / ASN',

  // Lanes & Logistics Plan - detail screens
  SearchByLaneName: 'Search by Lane Name',
  CurrentWeekSchedulesInfoTooltip:
    'Schedules falling in the current week. Expand the week to see its lanes by day.',
  WeeklyScheduleApprovalRequestInfoTooltip:
    'Weekly schedules awaiting your sign-off. Select lanes to approve or reject them.',
  ApprovedWeeklySchedulesInfoTooltip:
    'Weekly schedules that have been approved. Expand a week to review or edit its lanes.',
  LanesInLogisticsPlanInfoTooltip:
    'Lanes included in a logistics plan. Expand a lane to see its schedules and pick-up windows.',
  PreAlertsAsnInfoTooltip:
    'Pickup pre-alerts and delivery ASNs raised for your shipments.',
  NoOfLanes: 'No of Lanes',
  Lanes: 'Lanes',
  AutoApprovedSchedules: 'Auto Approved Schedules',
  NoLanesToShow: 'No lanes to show',
  WeekScheduleGroupName: 'Week {week} Schedule',
  OriginCountry: 'Origin Country',
  DestinationCountry: 'Destination Country',
  HUProduct: 'HU / Product',
  LaneName: 'Lane Name',
  ScheduleName: 'Schedule Name',
  ScheduledDay: 'Scheduled Day',
  ScheduleDate: 'Schedule Date',
  OriginName: 'Origin Name',
  DestinationName: 'Destination Name',
  Service: 'Service',
  LogisticPlanName: 'Logistic Plan Name',
  Recurrence: 'Recurrence',
  PickUpWindow: 'Pick Up Window',
  Action: 'Action',
  DeliveryASN: 'Delivery ASN',
  ReasonForApproving: 'Reason for Approving',
  ReasonForRejecting: 'Reason for Rejecting',
  SelectedSchedules: 'Selected schedules',
  ScheduleApprovedSuccessfully: 'Schedule approved successfully',
  ScheduleRejectedSuccessfully: 'Schedule rejected successfully',
  NoApproverFoundForSchedule:
    'No approver is assigned to the selected schedule, so the decision cannot be submitted.',

  //Shipment Details screen
  Info: 'Info',
  SupportContacts: 'Support Contacts',
  ContactType: 'Contact Type',
  DepartmentType: 'Department Type',
  ContactTelephoneNo: 'Contact Telephone No',
  ShipmentComments: 'Shipment Comments',

  //Claims
  Claims: 'Claims',
  ClaimId: 'Claim Id',
  ClaimType: 'Claim Type',
  CreateClaim: 'Create Claim',
  NPLCLaim: 'NPLC Claim',
  ClaimInTheAmountofUSD: 'Claim in the Amount of (USD)',
  DateFiled: 'Date Filed',
  NPLTrack: 'NPL Track',
  ClaimantsClaim: "Claimant's Claim",
  BillofLading: 'Bill of Lading',
  ClaimantsName: "Claimant's Name",
  ClaimantsAddress: "Claimant's Address",
  DateOfLossDamage: 'Date of Loss/Damage',
  LocationOfLossDamage: 'Location of Loss/Damage',
  EnterAddressExample: 'e.g. street name, city, state, country, postal code',
  ClaimisHereByFiledFor: 'Claim is Hereby Filed For',
  Shortage: 'Shortage',
  Overage: 'Overage',
  Damage: 'Damage',
  DetailedStatementShowingHowtheamountclaimedisDetermined:
    'Detailed statement showing how the amount claimed is determined',
  TotalAmoutClaimed: 'Total Amount Claimed',
  ClaimValueBasedOn: 'Claim Value Based On',
  FullInvoiceValue: 'Full Invoice Value',
  Repair: 'Repair',
  Allowance: 'Allowance',
  TheForegoingStatementFactsisHerebycertifiedasCorrect:
    'The foregoing statement of facts is hereby certified as correct',
  ClaimantsRep: "Claimant's Rep",
  ClaimantsSignature: "Claimant's Signature",
  Fax: 'Fax',
  EmailExamplePlaceholder: 'eg. xyz@example.com',
  SalesPerson: 'Sales Person',
  ClaimsRegulatoryNote:
    'Regulatory note: Under 49 CFR 370, carriers must acknowledge claims within 30 days and resolve within 120 days. The claim must be filed within 9 months of delivery (or reasonable delivery date for lost shipments).',
  ScrollDown: 'Scroll down',

  // FTP Users
  FtpUsers: 'FTP Users',
  UserName: 'User Name',
  FtpSftpServerDetails: 'FTP / SFTP Server Details',
  ServerAddress: 'Server Address',
  Username: 'Username',
  Port: 'Port',
  Protocol: 'Protocol',
  Password1: 'Password 1',
  Password2: 'Password 2',
  ReSendPasswords: 'Re-send Passwords',
  FtpUserNotFound: 'FTP user not found',
  Success: 'Success!',
  Copy: 'Copy',
  CopiedToClipboard: 'Copied to clipboard',
  CopyFailed: 'Failed to copy to clipboard',
  FtpPasswordsGeneratedMessage:
    'You have successfully generated new passwords. Copy them now!',
  FtpPasswordsCopyWarning:
    "Make sure you copy the above passwords now. We don't store them and you will not be able to see them again."
};
export default en;
